import { render, staticRenderFns } from "./ModalEditTurma.vue?vue&type=template&id=6c076952&scoped=true&"
import script from "./ModalEditTurma.vue?vue&type=script&lang=js&"
export * from "./ModalEditTurma.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTurma.vue?vue&type=style&index=0&id=6c076952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c076952",
  null
  
)

export default component.exports